import * as yup from 'yup';

const customerSchema = yup.object().shape({
  phoneNumber: yup
    .string()
    .required('Phone Number is required')
    .matches(/^\d{10}$/, 'Phone Number must be exactly 10 digits'),
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  idCardType: yup.string().notOneOf(['default'], 'ID Card Type is required'),
  idcardNumber: yup
    .string()
    .when('idCardType', {
      is: 'Aadharcard',
      then: yup.string().matches(/^\d{12}$/, 'Aadharcard Number must be 12 digits').required('ID Card Number is required')
    })
    .when('idCardType', {
      is: 'VoterIdCard',
      then: yup.string().matches(/^[A-Z]{3}[0-9]{7}$/, 'VoterIdCard Number must be in the format AAA1111111').required('ID Card Number is required')
    })
    .when('idCardType', {
      is: 'PanCard',
      then: yup.string().matches(/^([A-Z]){5}([0-9]){4}([A-Z]){1}$/, 'PanCard Number must be in the format ABCDE1234F').required('ID Card Number is required')
    })
    .when('idCardType', {
      is: 'DrivingLicense',
      then: yup.string().required('Driving License Number is required')
    })
    .when('idCardType', {
      is: 'passport',
      then: yup.string().required('Passport Number is required')
    })
    .when('idCardType', {
      is: 'cinNo',
      then: yup.string().required('Cin Number is required')
    })
    .required('ID Card Number is required'),
  address: yup.string().required('Address is required'),
  idFile: yup.mixed().nullable()
});

const roomSchema = yup.object().shape({
  roomNo: yup.string().required('Room Number is required'),
  roomType: yup.string().required('Room Type is required'),
  amount: yup.number().positive('Room amount must be positive').required('Room amount is required'),
  addBeds: yup.boolean(),
  noOfBeds: yup.number().when('addBeds', {
    is: true,
    then: yup.number().min(1, 'Number of beds must be at least 1').max(5, 'Number of beds cannot exceed 5')
  }),
  perBedAmount: yup.number().when('addBeds', {
    is: true,
    then: yup.number().positive('Per bed amount must be positive')
  }),
  extraBedsCharge: yup.number(),
  customers: yup
    .array()
    .of(customerSchema)
    .required('Must have customers')
    .min(1, 'Minimum of 1 customer required')
});

export const multiRoomBookingSchema = yup.object({
  checkInDate: yup
    .date()
    .required('Check-In Date is required')
    .test('not-past-date', 'Check-in date cannot be in the past', function (value) {
      if (!value) return true; // Let required validation handle empty values

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day

      const checkInDate = new Date(value);
      checkInDate.setHours(0, 0, 0, 0); // Set to start of day

      return checkInDate >= today;
    }),
  checkOutDate: yup
    .date()
    .required('Check-Out Date is required')
    .test('after-checkin', 'Check-out date must be after check-in date', function (value) {
      if (!value) return true; // Let required validation handle empty values

      const checkInDate = this.parent.checkInDate;
      if (!checkInDate) return true; // Let checkInDate validation handle this

      const checkIn = new Date(checkInDate);
      checkIn.setHours(0, 0, 0, 0);

      const checkOut = new Date(value);
      checkOut.setHours(0, 0, 0, 0);

      return checkOut >= checkIn;
    })
    .test('not-past-date', 'Check-out date cannot be in the past', function (value) {
      if (!value) return true; // Let required validation handle empty values

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day

      const checkOutDate = new Date(value);
      checkOutDate.setHours(0, 0, 0, 0); // Set to start of day

      return checkOutDate >= today;
    }),
  advanceAmount: yup
    .number()
    .min(0, 'Advance amount cannot be negative')
    .required('Advance amount is required'),
  totalAmount: yup.number(),
  advancePaymentMethod: yup.string().required('Payment method is required'),
  addBeds: yup.boolean(),
  noOfBeds: yup.number(),
  perBedAmount: yup.number(),
  rooms: yup
    .array()
    .of(roomSchema)
    .required('Must have rooms')
    .min(1, 'Minimum of 1 room required')
});
